/* eslint-disable no-unused-vars */
import axios from "axios";
import { Delete, Get, Post, PostFormData, Put } from "../Request";
import { SetUser, GetUser, RemoveUser } from "../Request/Auth";
export default {
  state: {
    allInstructorsIDsAndNames: [],
    userPurchaseAndBillings:[],
    instructorLicensingDetails:[],
    Users: [],
    SeminarBySeminarIdAndUserId:[],
    SeminarByGroup: [],
    courseTaughtById:[],
    courseTaught:[],
    SeminarByInstructorIdAndCourseId:[],
    userCEUs:[],
    AllUserNotesByUserId: [],
    BillingDetailsInfoByUserId: [],
    UserExams: [],
    AllHardshipApplications: [],
    rolePermission: {
      Name: "Super Admin",
      Id: 1,
      RolePermissions: [
        {
          ModuleId: 1,
          Module: "Dashboard",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 2,
          Module: "Team",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 3,
          Module: "Videos",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 4,
          Module: "Blog",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 5,
          Module: "Users",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 6,
          Module: "Testimonials",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 7,
          Module: "Practitioners",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 8,
          Module: "Courses",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 9,
          Module: "Seminars",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 10,
          Module: "Downloads",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 11,
          Module: "Forum",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 12,
          Module: "Sales",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 13,
          Module: "MembershipsPayment",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 14,
          Module: "Announcements",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 15,
          Module: "Store",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 16,
          Module: "Adverts",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 17,
          Module: "WebEditSection",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 18,
          Module: "HelpCenter",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 19,
          Module: "Coordinator",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 20,
          Module: "Polls",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 21,
          Module: "Setting",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
        {
          ModuleId: 22,
          Module: "DigitalManuals",
          View: false,
          Add: false,
          Edit: false,
          Delete: false,
        },
      ],
    },
    enrolledCourseOrSeminarByUserId: [],
    PreviewUser: null,
    Instructors: null,
    LoggedInUser: {},
    isLoggedIn: false,
    AllAddresses: null,
    MembershipOverviewByUserId: [],
    userOrders: [],
  },
  getters: {
    GetAllInstructorsIDsAndNames(state){
      return state.allInstructorsIDsAndNames
    },
    GetSeminarBySeminarIdAndUserId(state){
      return state.SeminarBySeminarIdAndUserId
    },
    GetSeminarByInstructorIdAndCourseId(state) {
      return state.SeminarByInstructorIdAndCourseId;
    },
    GetInstructorLicensingDetails(state) {
      return state.instructorLicensingDetails;
    },
    getUserCEUs(state) {
      return state.userCEUs;
    },
    getCourseTaught(state){
      return state.courseTaught;
    },
    getCourseTaughtById(state){
      return state.courseTaughtById;
    },
    getMembershipOverviewByUserId(state) {
      return state.MembershipOverviewByUserId;
    },
    getBillingDetailsInfoByUserId(state) {
      return state.BillingDetailsInfoByUserId;
    },
    getUserExams(state) {
      return state.UserExams;
    },
    getAllHardshipApplications(state) {
      return state.AllHardshipApplications;
    },
    GetAllAddresses(state) {
      return state.AllAddresses;
    },
    GetEnrolledCourseOrSeminarByUserId(state) {
      return state.enrolledCourseOrSeminarByUserId;
    },
    GetAllUserNotesByUserId(state) {
      return state.AllUserNotesByUserId;
    },
    GetUser(state) {
      return state.Users;
    },
    GetUserRolePermissions(state) {
      return state.rolePermission;
    },
    GetPreviewUser(state) {
      return state.PreviewUser;
    },
    GetInstructors(state) {
      return state.Instructors;
    },

    isLoggedIn(state) {
      var user = GetUser();
      if (user) {
        state.LoggedInUser = user;
        state.rolePermission = user.Roles;
        state.isLoggedIn = true;
      } else {
        state.LoggedInUser = null;
        state.rolePermission = null;
        state.isLoggedIn = false;
      }
      return state.isLoggedIn;
    },
    GetLoggedInUser(state) {
      return state.LoggedInUser;
    },
    GetUserOrders(state) {
      return state.userOrders;
    },
    GetAllSeminarByGroup(state) {
      return state.SeminarByGroup;
    },
    getUserPurchaseAndBillings(state) {
      return state.userPurchaseAndBillings;
    },
  },
  actions: {
    async AddAddress({ commit }, payload) {
      return await Post("Account/AddUserAddress", payload).then((res) => {
        return res.data;
      });
    },
    async AddOrUpdateNotes({ commit }, payload) {
      return await Post("UserNote/AddOrUpdateNotes", payload).then((res) => {
        return res.data;
      });
    },
    async CourseTaught({ commit }, payload) {
      return await Post("CourseTaught", payload).then((res) => {
        return res.data;
      });
    },
    async EditCourseTaught({ commit }, payload) {
      return await Put("CourseTaught", payload);
    },
    async EditMembershipWithoutPayment({ commit }, payload) {
      return await Put("Membership/EditMembershipWithoutPayment", payload);
    },
    async ToggleCourseTaughtActivity({ commit }, payload) {
      return await Put(`CourseTaught/ToggleCourseTaughtActivity?id=${payload}`);
    },
    async ResetCreadetsToZero({ commit }, payload) {
      const res = await Put(`User/InstructorLicensingDetailsResetToZero?Id=${payload}`);
      return res.data;
    },
    async SetHardshipApplicationsStatus({ commit }, payload) {
      return await Post("HardshipApplication/SetHardshipApplicationsStatus", payload).then((res) => {
        return res.data;
      });
    },
    async EditAddress({ commit }, payload) {
      return await Post("Account/UpdateUserAddress", payload);
    },
    async AllAddress({ commit }, payload) {
      return await Get(`Account/GetUserAddresses?UserId=${payload}`).then(
        (res) => {
          commit("SetUserAddresses", res.data.Data);
          return res.data.Data;
        }
      );
    },
    async GetCourseTaught({ commit }, payload) {
      return await Get(`CourseTaught?id=${payload}`).then(
        (res) => {
          commit("SetCourseTaught", res.data.Data);
          return res.data.Data;
        }
      );
    },
    async GetCourseTaughtById({ commit }, payload) {
      return await Get(`CourseTaught/GetCourseTaughtById?id=${payload}`).then(
        (res) => {
          commit("SetCourseTaughtById", res.data.Data);
          return res.data.Data;
        }
      );
    },
    async GetSeminarByInstructorIdAndCourseId({ commit }, payload) {
      return await Get(`Seminar/GetSeminarByInstructorIdAndCourseId?InstructorId=${payload.InstructorId}&CourseId=${payload.CourseId}&Date=${payload.Date}`).then(
        (res) => {
          commit("SetSeminarByInstructorIdAndCourseId", res.data.Data);
          return res.data.Data;
        }
      );
    },
    async GetAllUserNotesByUserId({ commit }, payload) {
      return await Get(
        `UserNote/GetAllUserNotesByUserId?UserId=${payload.id}`
      ).then((res) => {
        commit("SetAllUserNotesByUserId", res.data.Data);
        return res.data.Data;
      });
    },
    async GetEnrolledCourseOrSeminarByUserId({ commit }, payload) {
      return await Get(`Enrollment/GetEnrolledCourseOrSeminarByUserId?userId=${payload.id}`).then((res) => {
        commit("SetEnrolledCourseOrSeminarByUserId", res.data.Data);
        return res.data.Data;
      });
    },
    async DeleteEnrolledCourseOrSeminarById({ commit }, payload) {
      return await Delete(`Enrollment/DeleteEnrolledCourseOrSeminarById?ID=${payload}`).then((res) => {
        return res.data;
      });
    },
    async DeleteAddress({ commit }, payload) {
      return await Delete(
        `Account/DeleteUserAddresses?Id=${payload}`,
        payload
      ).then((res) => {
        console.log(res);
      });
    },
    async DeleteUser({ commit }, payload) {
      return await Post(`Account/DeleteUser?userId=${payload}`).then((res) => {
        return res.data;
      });
    },
    async DeleteCourseTaught({ commit }, payload) {
      return await Delete(`CourseTaught?id=${payload}`).then((res) => {
        return res.data;
      });
    },
    async DeleteUserNotesById({ commit }, payload) {
      return await Delete(`UserNote/DeleteUserNotesById?id=${payload}`).then(
        (res) => {
          return res.data;
        }
      );
    },
    async DeleteUserExamById({ commit }, payload) {
      return await Delete(
        `UserExams/DeleteUserExamById?examId=${payload}`
      ).then((res) => {
        return res.data;
      });
    },
    async DeleteHardshipApplication({ commit }, payload) {
      return await Delete(
        `HardshipApplication/DeleteHardshipApplication?Id=${payload}`
      ).then((res) => {
        return res.data;
      });
    },
    async DeleteUserCEUs({ commit }, payload) {
      return await Delete(
        `UserCEUs/DeleteUserCEUs?Id=${payload}`
      ).then((res) => {
        return res.data;
      });
    },
    async GetAllUser({ commit }, payload) {
      return await Get(
        `User/getall?pageNumber=${payload.page}&pageSize=${payload.pagesize}&search=${payload.search}&filters=${payload.filters}`
      )
        .then((res) => {
          commit("SetUsers", res.data.Data.users);
          return res.data.Data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async SignupUser({ commit }, payload) {
      return await PostFormData("Account/signup", payload);
    },
    async LoginUser({ commit }, payload) {
      return await Post("Account/login", payload).then((res) => {
        commit("SetUser", res.data);
        commit("SetRolePermission", res.data.LoginTokenResponseModel.Role[0]);
      });
    },
    async AddOrUpdateUserBillingDetailInfo({ commit }, payload) {
      return await Post(
        `UserBillingDetail/AddOrUpdateUserBillingDetailInfo`,
        payload
      ).then((res) => {
        return res.data;
      });
    },
    async EnrollCourseOrSeminarWithoutPayment({ commit }, payload) {
      return await Post(
        `Enrollment/EnrollCourseOrSeminarWithoutPayment`,
        payload
      ).then((res) => {
        return res.data;
      });
    },
    async GetRolePermissions({ commit }, payload) {
      return await Get(`Role/GetRoleById/${payload}`).then((res) => {
        if (res.data.Status) {
          commit("SetRolePermission", res.data.Data[0]);
        }
        return res.data.Data[0];
      });
    },
    async GetUserCEUs({ commit }, payload) {
      return await Get(`UserCEUs/GetUserCEUs?userId=${payload.id}&search=${payload.search}&StartDate=${payload.startDate}&EndDate=${payload.endDate}`).then((res) => {
        commit("SetUserCEUs", res.data.Data);
      });
    },
    async GetPreviewUser({ commit }, payload) {
      return await Get(`Account/GetUserWeb?id=${payload}`).then((res) => {
        commit("SetPreviewUser", res.data.Data);
      });
    },
    async UserPayment({ commit }, payload) {
      return await Post("UserPayment/ProcessPaymentBySeminarOrStore", payload).then((res) => {
        return res.data;
      });
    },
    async ProcessOfflinePaymentBySeminarOrStore({ commit }, payload) {
      return await Post("UserPayment/ProcessOfflinePaymentBySeminarOrStore", payload).then((res) => {
        return res.data;
      });
    },
    async AddToCart({ commit }, payload) {
      return await Post("Store/AddToCart", payload).then((res) => {
        return res.data;
      });
    },
    async PayUserExams({ commit }, payload) {
      return await Post("UserExams/PayUserExams", payload).then((res) => {
        return res.data;
      });
    },
    async AddOrUpdateUserCEUs({ commit }, payload) {
      return await Post("UserCEUs/AddOrUpdateUserCEUs", payload).then((res) => {
        return res.data;
      });
    },
    async ValidateCoupon({ commit }, payload) {
      return await Get(
        `Coupon/ValidateCoupon?Code=${payload.Code}&Type=${payload.Type}`
      ).then((res) => {
        return res.data;
      });
    },
    async GetAllInstructorsIDsAndNames({ commit }, payload) {
      return await Get(`User/GetAllInstructorsIDsAndNames/1?pageSize=-1`).then((res) => {
        commit("SetAllInstructorsIDsAndNames", res.data.Data.List);
      });
    },
    async GetInstructors({ commit }, payload) {
      return await Get(`User/GetInstructors`).then((res) => {
        commit("SetInstructors", res.data.Data);
      });
    },
    async GetUserExams({ commit }, payload) {
      return await Get(`UserExams/GetUserExams?userId=${payload.id}`).then(
        (res) => {
          commit("SetUserExams", res.data.Data);
        }
      );
    },
    async UpdateUser({ commit }, payload) {
      return await PostFormData("Account/UpdateUsers", payload).then((res) => {
        return res.data;
      });
    },
    async AddUserExams({ commit }, payload) {
      return await Post("UserExams/AddUserExams", payload).then((res) => {
        return res.data;
      });
    },
    Logout({ commit }, payload) {
      commit("Logout");
    },
    async UpdatePassword({ commit }, payload) {
      return await Put("User/ChangePassword", payload);
    },
    async UserMemberShipPayment({ commit }, payload) {
      return await Put("Membership/UserMemberShipPayment", payload);
    },
    async UserMemberShipOfflinePayment({ commit }, payload) {
      return await Put("Membership/UserMemberShipOfflinePayment", payload);
    },
    async UpdateUserExams({ commit }, payload) {
      return await Put("UserExams/UpdateUserExams", payload);
    },
    async ChangeAccountLockStatus({ commit }, payload) {
      return await Put(`User/ChangeAccountLockStatus?userId=${payload.Id}`);
    },
    async ConfirmAccountEmail({ commit }, payload) {
      return await Put(`Account/ConfirmAccountEmail?id=${payload.id}`).then((res)=>{
        return res.data;
      });
    },
    async BecomeInstructor({ commit }, payload) {
      return await Put(`User/PromoteToInstructor/${payload}`);
    },
    async ChangeInstructorLevel({ commit }, payload) {
      return await Put(`User/ChangeInstructorLevel?InstructorId=${payload.instructorId}&InstructorLevel=${payload.instructorLevel}`);
    },
    async GetMembershipOverviewByUserId({ commit }, payload) {
      return await Get(
        `User/GetMembershipOverviewByUserId?userId=${payload.id}`
      ).then((res) => {
        commit("SetMembershipOverviewByUserId", res.data.Data);
        return res.data;
      });
    },
    async GetAllHardshipApplications({ commit }, payload) {
      return await Get(
        `HardshipApplication/GetAllHardshipApplications?page=${payload.page}&pageSize=${payload.pagesize}&search=${payload.search}&filters=${payload.filter}`
      ).then((res) => {
        commit("SetAllHardshipApplications", res.data.Data);
        return res.data;
      });
    },
    async GetBillingDetailsInfoByUserId({ commit }, payload) {
      return await Get(
        `UserBillingDetail/GetBillingDetailsInfoByUserId?userId=${payload.id}`
      ).then((res) => {
        commit("SetBillingDetailsInfoByUserId", res.data.Data);
        return res.data;
      });
    },
    async GetOrders({ commit }, payload) {
      return await Get(`Store/GetOrders?UserId=${payload.id}`).then((res) => {
        commit("SetOrders", res.data.Data);
        return res.data.Data;
      });
    },
    async GetUserPurchaseAndBillings({ commit }, payload) {
      return await Get(`User/GetUserPurchaseAndBillings?UserId=${payload.id}`).then((res) => {
        commit("SetUserPurchaseAndBillings", res.data.Data);
        return res.data.Data;
      });
    },
    async GetAllSeminarByGroup({ commit }, payload) {
      return await Get(
        `Seminar/GetAllSeminarByGroup?page=1&pageSize=all&search=${payload.search}&filters=${payload.filter}`
      ).then((res) => {
        commit("SetAllSeminarByGroup", res.data.Data.List);
        return res.data.Data;
      });
    },
    // User/GetInstructorLicensingDetails?InstructorId=1'
    async GetInstructorLicensingDetails({ commit }, payload) {
      return await Get(
        `User/GetInstructorLicensingDetails?InstructorId=${payload}`
      ).then((res) => {
        commit("SetInstructorLicensingDetails", res.data.Data);
        return res.data.Data;
      });
    },
    async SendEmailForPassword({ commit }, payload) {
      return await Post(
        `User/SendLinkforResetPassword?email=${payload.email}`,
        payload
      ).then((res) => {
        return res.data;
      });
    },
    async SendEmailToUsers({ commit }, payload) {
      return await Post(`User/SendEmailToUsers`, payload).then((res) => {
        return res.data;
      });
    },
    async GetSeminarBySeminarIdAndUserId({ commit }, payload) {
      return await Get(
        `Seminar/GetSeminarBySeminarIdAndUserId?seminarId=${payload.seminarId}&userId=${payload.id}`
      ).then((res) => {
        commit("SetSeminarBySeminarIdAndUserId", res.data.Data);
        return res.data.Data;
      });
    },
  },
  mutations: {
    SetAllInstructorsIDsAndNames(state, payload){
      let data = payload.filter(
        (item) => item !== null
      ).sort((a, b) => {
        return a.Name.localeCompare(b.Name);
      });
      state.allInstructorsIDsAndNames = data
    },
    SetUserPurchaseAndBillings(state, payload){
      state.userPurchaseAndBillings = payload
    },
    SetSeminarBySeminarIdAndUserId(state, payload){
      state.SeminarBySeminarIdAndUserId = payload
    },
    SetInstructorLicensingDetails(state, payload) {
      state.instructorLicensingDetails = payload;
    },
    SetAllSeminarByGroup(state, payload) {
      let seminarsList = []; 
      payload.forEach((item)=>{
         item.Seminars.forEach((item)=>{
          seminarsList.push(item)
        })
      })
      state.SeminarByGroup = seminarsList;
    },
    SetSeminarByInstructorIdAndCourseId(state, payload) {
      state.SeminarByInstructorIdAndCourseId = payload;
    },
    SetCourseTaught(state, payload) {
      state.courseTaught = payload;
    },
    SetCourseTaughtById(state, payload) {
      state.courseTaughtById = payload;
    },
    SetUserCEUs(state, payload) {
      state.userCEUs = payload;
    },
    SetMembershipOverviewByUserId(state, payload) {
      state.MembershipOverviewByUserId = payload;
    },
    SetAllHardshipApplications(state, payload) {
      state.AllHardshipApplications = payload;
    },
    SetUserAddresses(state, payload) {
      state.AllAddresses = payload;
    },
    SetAllUserNotesByUserId(state, payload) {
      state.AllUserNotesByUserId = payload;
    },
    SetEnrolledCourseOrSeminarByUserId(state, payload) {
      const currentDate = new Date();
      let allSeminarDates = [];
      payload.forEach((item) => {
        item.SeminarDateAndTime.forEach((seminar) => {
          allSeminarDates.push({ ...seminar, itemId: item.Id });
        });
      });
      currentDate.setHours(0, 0, 0, 0);

      allSeminarDates.sort((a, b) => {
        const dateA = new Date(a.Date);
        dateA.setHours(0, 0, 0, 0);

        const dateB = new Date(b.Date);
        dateB.setHours(0, 0, 0, 0);

        if (dateA >= currentDate && dateB >= currentDate) {
          return dateA - dateB; 
        } else if (dateA >= currentDate) {
          return -1; 
        } else if (dateB >= currentDate) {
          return 1;
        } else {
          return dateB - dateA;
        }
      });

      let seminars = [];
      const itemIdSet = new Set();
      allSeminarDates = allSeminarDates.filter((item) => {
        if (itemIdSet.has(item.itemId)) {
          return false;
        } else {
          itemIdSet.add(item.itemId);
          return true;
        }
      });
      allSeminarDates.forEach((element) => {
        payload.forEach((item) => {
          if (element.itemId == item.Id) {
            seminars.push(item);
          }
        });
      });
      payload.forEach((item) => {
        if(item.SeminarDateAndTime.length == 0){
          seminars.push(item);
        }
      });
      state.enrolledCourseOrSeminarByUserId = seminars;
    },
    SetUsers(state, payload) {
      state.Users = payload.map((e) => {
        if (e.ProfileImage != "" && e.ProfileImage != null) {
          // e.ProfileImage = process.env.VUE_APP_IMG_URL + "/" + e.ProfileImage;
          e.ProfileImage = e.ProfileImage ? e.ProfileImage : e.ProfileImage;
        }
        return e;
      });
    },
    SetPreviewUser(state, payload) {
      (payload.ProfileImage =
        payload.ProfileImage != null &&
        payload.ProfileImage != undefined &&
        payload.ProfileImage != ""
          // ? process.env.VUE_APP_IMG_URL + "/" + payload.ProfileImage
          ? payload.ProfileImage
          : payload.ProfileImage),
        (state.PreviewUser = payload);
    },
    SetRolePermission(state, payload) {
      state.rolePermission = payload;
      var obj = {
        Id: state.LoggedInUser.Id,
        Username: state.LoggedInUser.Username,
        ProfileImage: state.LoggedInUser.ProfileImage,
        Roles: payload,
        Access_Token: state.LoggedInUser.Access_Token,
      };

      SetUser(obj);
    },
    SetUser(state, payload) {
      var obj = {
        Id: payload.Id,
        Username: payload.Username,
        ProfileImage:
          payload.ProfileImage != null &&
          payload.ProfileImage != undefined &&
          payload.ProfileImage != ""
            // ? process.env.VUE_APP_IMG_URL + "/" + payload.ProfileImage
            ? payload.ProfileImage
            : payload.ProfileImage,
        Roles: payload.LoginTokenResponseModel.Role[0],
        Access_Token: payload.LoginTokenResponseModel.access_token,
      };
      SetUser(obj);

      state.LoggedInUser = obj;
      state.isLoggedIn = true;
    },
    SetInstructors(state, payload) {
      state.Instructors = payload;
    },
    SetUserExams(state, payload) {
      state.UserExams = payload;
    },
    SetBillingDetailsInfoByUserId(state, payload) {
      state.BillingDetailsInfoByUserId = payload;
    },
    Logout(state) {
      RemoveUser();
      state.LoggedInUser = null;
      state.rolePermission = null;
      state.isLoggedIn = false;
    },
    SetOrders(state, payload) {
      state.userOrders = payload;
    },
  },
};
